import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, FileText, Loader2, GraduationCap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { academyAPI } from '@/lib/api';

export const AgentAcademyBadges = ({ npn }) => {
  const navigate = useNavigate();
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await academyAPI.agentBadges(npn);
      setBadges(r.data.items || []);
    } catch {
      setBadges([]);
    } finally {
      setLoading(false);
    }
  }, [npn]);
  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8" data-testid="agent-academy-loading">
        <Loader2 className="animate-spin text-slate-400" size={20} />
      </div>
    );
  }

  if (badges.length === 0) {
    return (
      <div className="py-8 text-center text-sm text-slate-500" data-testid="agent-academy-empty">
        <GraduationCap size={24} className="mx-auto mb-2 text-slate-300" />
        No training badges earned yet.
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-3" data-testid="agent-academy-badges">
      {badges.map((b) => (
        <div
          key={b.course_id}
          className="flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3"
          data-testid={`agent-academy-badge-${b.course_id}`}
        >
          <div className="w-10 h-10 rounded-full bg-amber-400 text-white flex items-center justify-center shrink-0">
            <Award size={20} />
          </div>
          <div>
            <div className="text-sm font-semibold text-amber-900">{b.title}</div>
            <div className="text-[11px] text-amber-700">
              Passed {b.passed_at ? new Date(b.passed_at).toLocaleDateString() : ''} · {b.best_score}%
            </div>
          </div>
          {b.gives_certificate && b.certificate_id && (
            <Button
              size="sm"
              variant="outline"
              className="ml-2"
              onClick={() => navigate(`/academy/certificate/${b.certificate_id}`)}
              data-testid={`agent-academy-cert-${b.course_id}`}
            >
              <FileText size={13} className="mr-1" /> Certificate
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default AgentAcademyBadges;
